<ng-container *ngrxLet="hints$; let hints">
    <div class="row">
        <div class="col">
            <p>{{ hints.description }}</p>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <h4>{{ hints.abbreviationsHeading }}</h4>
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>{{ hints.abbreviationsHead.abbreviation }}</th>
                        <th>{{ hints.abbreviationsHead.explanation }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let abbreviation of hints.abbreviations; trackBy: trackByFn">
                        <td>{{ abbreviation.abbreviation }}</td>
                        <td>{{ abbreviation.explanation }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</ng-container>
